import { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import "./DedCategoryList.css";
import { getDataForDedActivityCategoryPageApi, Activity  } from "../../lib/api";

const DedCategoryList = () => {
  const navigate = useNavigate();
  const [activities, setActivities] = useState<Activity[]>([]);
  const [query, setQuery] = useState("");
  const [activeId, setActiveId] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);

  // Fetch from API
  useEffect(() => {
    const fetchActivities = async () => {
      setLoading(true);
      try {
        const data = await getDataForDedActivityCategoryPageApi();
        setActivities(data);
      } catch (err) {
        console.error("Failed to fetch activities:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchActivities();
  }, []);

  const handleGetActivityLists = (id: number, url: string) => {
    setActiveId(id);
    navigate(`/dubai-economy/activities/${url}`);
  };

  const filteredActivities = useMemo(() => {
    if (!query) return activities;
    const lowerQuery = query.toLowerCase();
    return activities.filter((category) => {
      const categoryMatches = category.name.toLowerCase().includes(lowerQuery);
      const subActivityMatches = category.subActivities?.some((sub) =>
        sub.activityCode.toLowerCase().includes(lowerQuery)
      );
      return categoryMatches || subActivityMatches;
    });
  }, [query, activities]);

  return (
    <div className="container py-4 py-md-5">
      {/* Search Section */}
      <div className="ded-activity-search-section mb-4">
        <div className="ded-activity-search-wrap">
          <input
            className="form-control ded-activity-search"
            placeholder="Search activity"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          <button className="ded-activity-search-btn" type="button">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="11" cy="11" r="8"></circle>
              <path d="M21 21L16.65 16.65"></path>
            </svg>
          </button>
        </div>
      </div>

      {/* Grid */}
      <div className="row g-3">
        {loading && <div className="col-12">Loading activities...</div>}

        {!loading &&
          filteredActivities.map((item) => (
            <div key={item.categoryID} className="col-6 col-md-4 col-lg-3">
              <div className={`ded-activity-tile ${(item.categoryID === activeId) ? "active" : ""}`} onClick={() =>
                  handleGetActivityLists(item.categoryID, item.slug)
                }>
                <img src={item.iconUrl} alt={item.name} className="ded-activity-icon" />
                <div className="ded-activity-name">{item.name}</div>
              </div>
            </div>
          ))}

        {!loading && filteredActivities.length === 0 && (
          <div className="col-12 text-muted small">
            No results for “{query}”.
          </div>
        )}
      </div>
    </div>
  );
};

export default DedCategoryList;
